import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import year from '../resources/p2_img1.svg'
import triangle from '../resources/p2_img2.svg'


class Section2 extends Component {
  render() {
    return (
      <section id="page_2">
        <div className="container">
          <div className="row">
            <img className="col-md-6 col-sm-6 col-xs-12" src={year} alt='year' />
            <div className="col-md-5 col-sm-5 col-xs-12 title">
              <div className="mainText">
                英語教育の激変
              </div>
              <div className="subText">
                グローバル化が急速に進んでいる中、日本の英語教育がついに2020年から本格的に変わります。
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="col-md-5 col-sm-5 col-xs-12 text-right">
              </div>
              <div className="col-md-2 col-sm-2 text-center">

              </div>

              <div className="col-md-5 col-sm-5 col-xs-12">
                <div className="level_box">
                  <div className="top_title">
                    <span className="title_dot text-center">小</span>
                    <span className="title_content">英語教科スタート</span>
                  </div>
                  <ul>
                    <li>
                      <span className="highlight">小学校3~4年生</span>：<span className="highlight red_font">「聞く・話す」</span>
                      の「外国語活動」がスタート。

                    </li>
                    <li>
                      <span className="highlight">小学校5～6年生</span>：英語が教科化され、成績評価がされるように。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xs-12">
              <div className="col-sm-5 col-xs-12 text-right">
                <div className="current_edu">
                  <span className="current_text">日本語で学ぶ英語の授業</span>
                  <span className="current_dot">中</span>
                </div>
              </div>
              <div className="col-sm-2 hidden-xs">
                <div className="vertical_text">
                  <div className="col-sm-6 vertical_now">現<br />在<br />の<br />英<br />語<br />教<br />育<br />↓</div>
                  <div className="col-sm-6 vertical_2020">2<br />0<br />2<br />0<br />年<br />か<br />ら<br />の<br />英<br />語<br />教<br />育<br />↓</div>
                </div>
              </div>
              <div className="col-sm-5 col-xs-12">
                <div className="level_box">
                  <div className="top_title">
                    <span className="title_dot text-center">中</span>
                    <span className="title_content">英語で学ぶ英語の授業</span>
                  </div>
                  <ul>
                    <li>
                    　プレゼンテーション、ディベート、ディスカッションなどの<span className="highlight red_font">「話す」</span>
                      スキルを育てる。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xs-12">
              <div className="col-sm-5 col-xs-12 text-right">
                <div className="current_edu">
                  <span className="current_text">2技能評価の大学入試<br/>センター試験</span>
                  <span className="current_dot" style={{marginTop: -48}}>高</span>
                </div>
              </div>
              <div className="col-sm-offset-2 col-sm-5 col-xs-12">
                <div className="level_box">
                  <div className="top_title">
                    <span className="title_dot text-center">高</span>
                    <span className="title_content">大学入 学共通テストで4技能評価</span>
                  </div>
                  <ul>
                    <li>
                      「聞く」「読む」「書く」<span className="highlight red_font">「話す」</span>の4技能を重視し、評価される。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-offset-3 col-sm-6 col-xs-12 text-center" style={{zIndex: 50}}>
            <img src={triangle} className="triangle" alt='triangle'/>
            <div className="triangle_text1">日本の英語教育に不足しているのは</div>
            <div className="triangle_text2"><span className="highlight red_font">「話す」</span>スキル</div>
          </div>

          <div className="col-xs-12 between_1_2">
            <div className="col-sm-offset-2 col-sm-3 col-xs-12 between_1_2_text1">
              悩みを抱えているのは、
              生徒ではなく<span className="blue_font">英語教師。</span>
            </div>
            <ul className="col-sm-offset-2 col-sm-5 col-xs-12 between_1_2_text2">
              <li>英語を「話す」スキルに自信がない</li>
              <li>効果的な指導方法が見つからない</li>
              <li>生徒一人ひとりに合った指導をしたい</li>
              <li>生徒の学習モチベーションを上げたい</li>
              <li>授業の準備に時間をかけたくない</li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default Section2;



// WEBPACK FOOTER //
// ./src/sections/Section2.js